import { mapKeys } from "lodash";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import Admin from "apis/Admin";

// First, create the thunk
export const artistListRequest = createAsyncThunk(
  "artistList",
  async (limitArr) => {
    const [filter, start, limit, startDate, endDate] = limitArr;
    const response = await Admin.get(`getAllArtists?searchType=${filter}&startIndex=${start}&limit=${limit}&startDate=${startDate}&endDate=${endDate}`);
    return response.data.data;
  }
);

export const toggleAdminVerify = createAsyncThunk(
  "adminVerify",
  async (id, { getState }) => {
    const state = getState();
    const data = {
      artistId: id,
      adminVerified: !state.artistList.list[id].adminVerified,
    };

    await Admin.post("adminVerify", data);
    return data;
  }
);

// Then, handle actions in your reducers:
const artistListSlice = createSlice({
  name: "artistList",
  initialState: {list: {}, totalList: 0},
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    emptyArtistList() {
      return {};
    },
  },
  extraReducers: {
    // Add reducers for additional action types here, and handle loading state as needed
    [artistListRequest.fulfilled]: (state, action) => {
      return { 
        ...state,
        list: {...mapKeys(action.payload.artists, "_id")},
        totalList: action.payload.totalArtistsCount
      };
    },
    [toggleAdminVerify.fulfilled]: (state, action) => {
      return {
        ...state,
        list: {
          ...state.list,
          [action.payload.artistId]: {
            ...state.list[action.payload.artistId],
            adminVerified: action.payload.adminVerified,
          },
        }  
      };
    },
  },
});

export const { emptyArtistList } = artistListSlice.actions;
export default artistListSlice.reducer;
